import { useCallback, useEffect, useState } from "react";
import { IError } from "itsf-ui-common";
import { IHppRequest, THpp } from "./IElavonPayment";
import { initHppIframe } from "@utils/initHppIframe";
import { useFetch } from "@hooks/useFetch";

interface IParams {
    validatePaymentApiRoute: string;
    iframePaymentApiRoute: string;
    successCallback(): void;
    errorCallback?(error: IError): void;
}

export const useElavonPaymentIframe = (props: IParams) => {
    const { validatePaymentApiRoute, iframePaymentApiRoute, successCallback, errorCallback } = props;
    const [iframeFetchState, { get, post }] = useFetch();
    const [iframeKey, setIframeKey] = useState(0);

    const submitPayment = useCallback(
        (hppResponse: THpp) => {
            post<boolean>(validatePaymentApiRoute, { body: { hppResponse }, forwardError: true })
                .then((response) => {
                    if (response) {
                        successCallback();
                    }
                })
                .catch(() => setIframeKey((prevState) => prevState + 1));
        },
        [post, successCallback, validatePaymentApiRoute]
    );

    const getIFrame = useCallback(() => {
        get<IHppRequest>(iframePaymentApiRoute, { forwardError: Boolean(errorCallback) })
            .then((result) => {
                if (result?.hppRequest) {
                    initHppIframe({
                        iframeParams: {
                            idOfEmbeddedButton: "autoload",
                            idOfTargetIframe: "target-iframe",
                            callback: (hppResponse) => submitPayment(hppResponse),
                            hppRequest: result.hppRequest,
                        },
                        hppUrl: process.env.ELAVON_URL,
                    });
                }
            })
            .catch(errorCallback);
    }, [errorCallback, get, iframePaymentApiRoute, submitPayment]);

    useEffect(() => {
        getIFrame();
    }, [getIFrame]);

    return { iframeFetchState, iframeKey, getIFrame };
};
